export const SITE = {
  name: "Athlevo IT Solution",
  url: "https://athlevoitsolution.com",
  tagline: "Technology That Moves Your Business Forward.",
  email: "info@chandrabhansingh.in",
  phones: [
    { label: "+91 7024315567", href: "tel:+917024315567" },
    { label: "+91 9755121478", href: "tel:+919755121478" },
  ],
  whatsapp: "917024315567",
  address: "Office No. 69, Ratan Colony, New Jail Road, Huzur, Bhopal, Madhya Pradesh 462038, India",
  // Business hours. Set `open24x7` to false (and edit `label`) if the team is not reachable round the clock.
  hours: { open24x7: true, label: "Open 24 hours, 7 days a week", short: "Open 24/7" },
};

/**
 * CRM lead capture. Every inquiry form on the site posts here (see InquiryForm.jsx).
 * The key is a public ingestion key, safe to ship in client code.
 */
export const CRM = {
  endpoint: "https://leadcrm.ashawebtechitsolutions.com/api/v1/leads",
  key: "lhk_767f56e0dfdaf2ba946f922081924f6fc035e16d",
};

/**
 * Live statistics. Counts are calculated from the current date, so nobody has to edit them.
 *   clients  : 370+ on the base date, +1 every 7 days
 *   projects : 710+ on the base date, +1 every 7 days
 *   years    : 9+ on the base date, +1 on each yearly anniversary of the base date
 *   rating   : fixed at 4.9 (never auto-increased)
 * To re-baseline, change STATS_BASE.date and the starting values.
 */
export const STATS_BASE = { date: "2026-11-05", clients: 370, projects: 710, years: 9, rating: 4.9 };

export const getLiveStats = (now = new Date()) => {
  const [y, m, d] = STATS_BASE.date.split("-").map(Number);
  const base = new Date(y, m - 1, d);
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const days = Math.max(0, Math.round((today - base) / 86400000));
  const weeks = Math.floor(days / 7);
  let years = now.getFullYear() - y;
  const anniversaryNotReached = now.getMonth() < m - 1 || (now.getMonth() === m - 1 && now.getDate() < d);
  if (anniversaryNotReached) years -= 1;
  return {
    clients: STATS_BASE.clients + weeks,
    projects: STATS_BASE.projects + weeks,
    years: STATS_BASE.years + Math.max(0, years),
    rating: STATS_BASE.rating,
  };
};

export const DEFAULT_WA_TEXT =
  "Hello Athlevo IT Solution, I would like to discuss a digital project for my business.";

export const waLink = (text = DEFAULT_WA_TEXT) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;

export const mailLink = (subject, body = "") =>
  `mailto:${SITE.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

export const IMG = (name) => `/images/${name}.webp`;

/** Descriptive alt text for every photo in /public/images (describes what is actually in the picture). */
export const IMAGE_ALT = {
  academy: "Young footballers playing a match on a grass pitch",
  club: "Aerial view of outdoor tennis courts surrounded by trees",
  coach: "Personal trainer coaching a client through a weighted exercise in a gym",
  dance: "Dancer rehearsing in a bright studio with large windows",
  equipment: "Rack of dumbbells in a gym",
  events: "Runners crossing the road during a city race",
  gym: "Modern gym floor with strength and cardio machines",
  hero: "Gym floor with rows of dumbbells and an athlete training in the background",
  martial: "Two martial artists grappling on a training mat",
  nutrition: "Colourful plant-based meal bowl with fresh vegetables",
  spa: "Hot stone massage treatment decorated with white orchids",
  studio: "Bright fitness studio with cardio equipment and large windows",
  swim: "Swimming pool lanes separated by lane ropes",
  trainer: "Personal trainer guiding a client through a push-up exercise",
  yoga: "Group stretching together during a yoga session",
};
export const altFor = (name) => IMAGE_ALT[name] || "Athlevo IT Solution";
